<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-12-30 20:40:32
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-12-30 22:17:47
-->
<template>
  <el-dialog width="480px" :visible.sync="dialogVisible" :append-to-body='true' show-close @close="resetForms()" :close-on-click-modal="false">
    <template slot="title">
      <p><span>补充抖音主页链接</span></p>
    </template>
    <el-form
      :inline="true"
      :model="formData"
      label-width="110px"
      ref="from"
      :rules="rules"
    >
      <el-form-item label="抖音主页链接" prop="main_url">
        <el-input v-model="formData.main_url" placeholder="请输入达人的抖音主页链接" style="width: 315px;"></el-input>
        <p><a class="fz-14 link primary" href="https://yangxuan.feishu.cn/docs/doccnTVQKozSooIyaIQSBpOI2Od" target="_blank">如何获取达人主页链接？</a></p>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="submit">确认</el-button>
    </span>
  </el-dialog>
</template>
<script>
import throttle from 'lodash/throttle';
import { editTalent } from '@/api/talentCRM'
export default {
  name: 'addJxHomeUrl',
  data() {
    return {
      dialogVisible: false,
      formData: {
        anchor_id: '',
        main_url: '',
        anchor_account: '',
        anchor_name: '',
        is_effective: ''
      },
      rules: {
        main_url: [
          { required: true, message: '请输入达人的抖音主页链接', trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    show(obj) {
      this.formData = {...obj};
      this.dialogVisible = true;
    },
    resetForms() {
      this.$refs['from'].resetFields();
    },
    submit: throttle(function() {
      this.$refs.from.validate(async valid => {
        if(!valid) return
        const { formData: {
          main_url,
          anchor_id,
          anchor_name,
          is_effective,
          anchor_account
        } } = this
        const { code } = await editTalent({main_url, anchor_id, anchor_name, is_effective, anchor_account})
        if(code !== 0) return
        this.$message.success('达人抖音主页链接添加成功')
        this.$emit('refresh')
        this.handleClose()
      });
    }, 1000),
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>